export default "__VITE_ASSET__DlCB3Cti__"